/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-31 14:23:29
 * @LastEditors: linxi
 * @LastEditTime: 2021-06-02 15:44:55
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";
export interface StockMaintenanceParams {
  id?: number;
  current?: number;
  size?: number;
  total?: number;
  name?: string;
  timeHead?: string;
  timeTail?: string;
  pages?: number;
}

export interface StockMaintenanceBody {
  createTime?: string;
  createUser?: string;
  id?: number;
  isDeleted?: number;
  mainUserId?: number;
  mainUserName?: string;
  maintainCategory?: number;
  maintainTime?: string;
  no?: string;
  remark?: string;
  sort?: number;
  state?: number;
  status?: number;
  storehouseId?: number;
  storehouseName?: string;
  tenantId?: number;
  updateTime?: string;
  updateUser?: number;
}

export function getStockMaintenance(params: StockMaintenanceParams): Request {
  return {
    // url: `${API_PREFIX}/page`,
    url: `${API_PREFIX}/blade-store/maintain/page`,
    method: "GET",
    params,
  };
}

export function getStockMaintenanceDetail(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/detail`,
    method: "GET",
    params: {
      id
    }
  }
}

export function removeStockMintenance(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/removeall`,
    method: "POST",
    params: {
      ids: id
    }
  }
}

export function maintenanceCompleted(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/updatefinish`,
    method: "POST",
    body: {
      id
    }
  }
}

export function submitStockMaintenance(body: StockMaintenanceBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/submit`,
    method: "POST",
    body
  }
}